import React from 'react';
import { useLocation } from 'react-router-dom';
import SavedQuotes from '../components/SavedQuotes';

const ExportQuotePage = () => {
  const location = useLocation();
  const returnPath = location.state?.from || '/configurator-select';

  return <SavedQuotes asPage forceEditing returnPath={returnPath} />;
};

export default ExportQuotePage;
